var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCannery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.75 31C348.914 31 424.5 68.793 424.5 115.375C424.5 161.957 348.914 199.75 255.75 199.75C162.586 199.75 87 161.957 87 115.375C87 68.793 162.586 31 255.75 31ZM87 175.141C121.277 207.66 182.801 227.875 255.75 227.875C329.578 227.875 391.102 207.66 424.5 175.141V396.625C424.5 443.207 348.914 481 255.75 481C162.586 481 87 443.207 87 396.625L87 175.141ZM292.145 382.968C311.896 371.803 325.234 351.046 325.234 327.181C325.234 302.175 310.62 280.546 289.283 269.844C285.573 267.983 281.116 270.572 281.116 274.641V322.988L259.057 344.497L236.998 322.988V274.641C236.998 270.572 232.542 267.983 228.831 269.844C207.495 280.546 192.881 302.175 192.881 327.181C192.881 351.046 206.218 371.803 225.969 382.968V425.156C225.969 434.066 233.376 441.289 242.513 441.289H275.601C284.738 441.289 292.145 434.066 292.145 425.156V382.968Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCannery);
export default __webpack_public_path__ + "static/media/cannery.75f8b53f18c3b2804a3479217d7e4bdf.svg";
export { ForwardRef as ReactComponent };